import React, { useState } from "react";
import {
  CheckboxContainer,
  CheckboxLabel,
  CheckboxInput,
  CheckboxIcon,
} from "./styles";
import { isStringEmpty } from "../../../utils/handler_validations";

const propsTemplate = () => ({
  textError: "",
  title: "",
  hasABS: false,
  onChangeABS: (newState = false) => {},
});
const ABSCheckbox = (props = propsTemplate()) => {
  const [checked, setChecked] = useState(props.hasABS);

  // Función para manejar el cambio de estado del checkbox
  const handleChange = () => {
    const newCheckedState = !checked;
    setChecked(newCheckedState);
    props.onChangeABS && props.onChangeABS(newCheckedState);
  };

  return (
    <CheckboxContainer>
      {!isStringEmpty(props.title) && (
        <label className="txt-title">{`${props.title}${
          props.isRequired ? " *" : ""
        }`}</label>
      )}
      <CheckboxLabel>
        <CheckboxInput
          type="checkbox"
          checked={checked}
          onChange={handleChange}
        />
        <CheckboxIcon checked={checked} />
        <span>Sistema ABS</span>
      </CheckboxLabel>
      {!props.hasABS && <label className="txtError">{props.textError}</label>}
    </CheckboxContainer>
  );
};

export default ABSCheckbox;
